/**
 * Get the user-agent from the request on the server
 * or the navigator on the client
 * @param {object} req - request object
 * @returns {string} - the user agent
 */

export default function getUserAgent(req) {
  try {
    return req?.headers?.['user-agent'] || window?.navigator?.userAgent
  } catch (err) {
    return ''
  }
}
